(function (factory) {
  if (typeof define === 'function' && define.amd) {
    define(['jquery'], factory);
  } else if (typeof module === 'object' && typeof module.exports === 'object') {
    factory(require('jquery'));
  } else {
    factory(jQuery);
  }
})(function (jQuery) {
  // German
  jQuery.timeago.settings.strings = {
    prefixAgo: translationList["5712"],
    prefixFromNow: translationList["5713"],
    suffixAgo: "",
    suffixFromNow: "",
    seconds: translationList["5714"],
    minute: translationList["5715"],
    minutes: "%d " + translationList["5716"],
    hour: translationList["5717"],
    hours: "%d " + translationList["5718"],
    day: translationList["5719"],
    days: "%d " + translationList["5720"],
    month: translationList["5721"],
    months: "%d " + translationList["5722"],
    year: translationList["5723"],
    years: "%d " + translationList["5724"]
  };
});